// Generated by pnpm images:blurhash. Do not edit manually.

export const IMAGE_BLUR_PLACEHOLDERS = {
  '/images/apps/about/sec_02_bg_01.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRjYAAABXRUJQVlA4ICoAAADwAgCdASogABIAPt1orVEopiQiqAgBEBuJaQAAPa6WAAD+8GyEpk/mAAA=',
  },
  '/images/apps/about/sec_02_bg_01.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAABwAwCdASoWACAAPt1orFC3JiQqqAgC4BuJZQCw7Bdvb1hLTZQA/vCez3h/DnESlzG/UyzJhtk1oklmqdDb0imHgsR814AA',
  },
  '/images/apps/about/sec_02_img_03.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRmwAAABXRUJQVlA4IGAAAACwBACdASogABYAPt1iqU4opaQiKA1REBuJQBXJ5ohTApu9/CgCYOI04yaLx1MgAP7Dke1KzV+ZvKoBysqHmZVAkojdQJoSI4+HwcT8eHa+I81R0mCeS4l4Jrk0CtSIAAA=',
  },
  '/images/apps/about/sec_02_img_04.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRlwAAABXRUJQVlA4IFAAAABwBACdASogABYAPt1eqE2opSOiKA1REBuJZwC3uHNtt7pwhjNXP0EixBqxZADTRJyK350PAU5Ejj9BlryASe9AVwullUv0ST3DpENNvCgAAA==',
  },
  '/images/apps/about/sec_02_img_07.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRm4AAABXRUJQVlA4IGIAAAAwBACdASogABYAPs1YoEynpaMiN/qoAPAZiUAYbGkQOcsaBywISzWr2AAA/uqNevohcf1a2yH3SKiXPzYPDi35zSodCrGpdXyTVZ4MuKh09rtogfrlzj8z7OpOJHx/scAAAA==',
  },
  '/images/apps/about/sec_02_img_09.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRmwAAABXRUJQVlA4IGAAAAAwBQCdASogABYAPt1ao00opSMiMBgMARAbiWMAwcw0Lezw3Nqr1UdgBjfXwJQt80oa0AD+cOrNrUBsVLm/MLUSbmD2szuW81pxWG6Gfvkpz5fdoyQx9pDISHwBw25/4AA=',
  },
  '/images/apps/about/sec_02_img_10.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAACwAwCdASogABYAPtVap0y7pagiMAwDcBqJYwAAEL7/u91e1H8AAADsjsdaKHYt7y76NwgxKNT7W5Yu62uRi6wAAAA=',
  },
  '/images/apps/about/sec_02_video_01_poster.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAADwAgCdASogABIAPt1orFEopaQiqAgBEBuJaQAAPbqk4AD+8HMcIZpCxpdAgoAA',
  },
  '/images/apps/about/sec_04_bg_01.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRnAAAABXRUJQVlA4IGQAAADwAwCdASogABAAPt1cpkyopSOiMAgBEBuJagCdMoMYAOST+HIYSyyAAP76dvJnwbVx10aiogQXxIW0RCY3JY73FAaNBIOCKW3U7OWVRfvsNNp0S0R3preubHisnEUqnZZPoAAA',
  },
  '/images/apps/about/sec_04_bg_01.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRloAAABXRUJQVlA4IE4AAACwAwCdASogAA8ALqVut1ujKKioiICkSxAE6ZQZLGSaJM3JDli8AAD+8tdih2RyCc8Y5gOlt0jRhaCkxJ20dwfZa/wsry5O2dQxggQAAAA=',
  },
  '/images/apps/about/sec_04_bg_02.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRmgAAABXRUJQVlA4IFwAAADwAwCdASogABAALqVut1ujKKioiICkS2AE6ZQYwASZDQsvXh3VH/ZYAP71nZ1bBGbqOZvQaZva3Os2geHGvd+XO8fRxi4J5AD4f0TzDiCTrz+/uGYTWvPijVoAAA==',
  },
  '/images/apps/about/sec_04_bg_02.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRlwAAABXRUJQVlA4IFAAAACwAwCdASogAA8ALqVut1ujKKioiICkS2AE6ZQANTqkGwz5+7wPwAD+9ZftvOrq6Aqfg5NV52cojx8XxWeA/9TQWDfikJ151TlebaF7XUBgAA==',
  },
  '/images/apps/about/sec_04_img_01.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRnIAAABXRUJQVlA4IGYAAAAwBACdASoZACAAPtlWpEyoKSOiN/VYASAbCWMArDNkAabiK/ZwphdhGrAA/u/OtPDCWILEpoRbiqwvXZu2ni3Q/9/RT03xw7fRkOJ9vVXkbJAOxw6Qso3gPyG9Mflr/AQxmN/OwAA=',
  },
  '/images/apps/about/sec_04_img_01_m.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRngAAABXRUJQVlA4IGwAAACQBACdASogABsAPt1ep00opSOiMAgBEBuJQBYj6hjKBTd9r9vP/GPbh4GisAAA/tNNFfp2PU2t7wO4dvn4p4YeFkSa2SiluutdcLwJ/llp8HCSZCkJhDj3/0zlBC0mAxIRZTDR9B20poWVAAA=',
  },
  '/images/apps/about/sec_04_img_02.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRlQAAABXRUJQVlA4IEgAAAAQBACdASoZACAAPslYokyqJaMiN/qoAUAZCWkAAHbMsNTjqU3mb3gp0AD+6ZpqFs007EAT0Qwf8b0yDKlyeHXcow+mu8HgAAA=',
  },
  '/images/apps/about/sec_04_img_02_m.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRlQAAABXRUJQVlA4IEgAAABQBACdASogABsAPtVWo0yoLaMiN/VYAbAaiWcAz2RO25jCsVL8b8xZjIAAAP7r7rP2i71rF5XazMfJUHbBM7+CeAtXWqIVAAA=',
  },
  '/images/apps/about/sec_04_img_03.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRlgAAABXRUJQVlA4IEwAAAAQBACdASoZACAAPsVOoEy/pCMiN+gD8BiJaQAAQUTe7jx4e+LUQvtgAAD9EkhHfWKcp39rVPkGaEegnjJ9nXMzhRUWu4pr2FeBAAAA',
  },
  '/images/apps/about/sec_04_img_03_m.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAACQAwCdASogABsAPsFQn0y0JSMiN+gCgBgJaQAAYaX0AAkQcbMAAP5vuQcTWXgVMAFifL8Cmv/u5Gopb6f6/16EYg/hAAAA',
  },
  '/images/apps/about/sec_05_img_01.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRnIAAABXRUJQVlA4IGYAAABwBQCdASoZACAAPt1UpkyopCOiN/VYARAbiWIAsR7aQadODYLqGZ9r9fHJap5zpHV/iZ8AAP3Oa1aTtpmxXv6+I6iivbSQ1RymQ1T23ShkIXUz1kNZXHUkqyW56rwdtN2e1m18gAA=',
  },
  '/images/apps/about/sec_05_img_01_m.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRmoAAABXRUJQVlA4IF4AAAAwBQCdASogABsAPt1gp0yopaOiMAgBEBuJQBOmYl//BKc3B6b4mjFNGQI5NzVHILUtgADD7eZdjvc/fON2kCQy5TTSv9Ux24tldVL6CicrEJquAvr7C+dtg8BaAAAA',
  },
  '/images/apps/about/sec_05_img_02.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRmoAAABXRUJQVlA4IF4AAAAQBQCdASoZACAAPs1MokyqpCMiN/qoAVAZiUAWI/HZcS91RhPRsVO4ccLU4R5BbeQAAP6M9Apzy7I93TlkRyLUuF+uq3PV98ENCcfh5bOoRZgI0EdMBFaIDNNXO9AA',
  },
  '/images/apps/about/sec_05_img_02_m.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRmQAAABXRUJQVlA4IFgAAAAwBACdASogABsAPtVco0yoJaMiN/VYAQAaiUAZEwKpYP7bJlvWAxR1XwAA/tA2XLv/HFnlB8XLbZYMPJ2RU+ffIENc0QcSCBsEpGulpFzwIbO40sNsBAAA',
  },
  '/images/apps/about/sec_05_img_03.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRl4AAABXRUJQVlA4IFIAAABQAwCdASoZACAAPt1cpkyxJSOiMAgCIBuJYwDKMoAEILxlAAD+7Iod7DhERsK5GxLePWdTS160561f8Gz5DZ9+kw/azCswMHb3N2frPKXSAAAA',
  },
  '/images/apps/about/sec_05_img_03_m.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRl4AAABXRUJQVlA4IFIAAACQAwCdASogABsAPtFWpUy6pKOiMAwDUBoJQBOmbICG5MzAs50AAP7s2cGPPSEFcQE92T0mUIvvmSI7RnfgrH9N0ojduOUqDCfPqdspkISDQAAA',
  },
  '/images/apps/about/subtop_bg_01.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkIAAABXRUJQVlA4IDYAAABwAwCdASogAA0APt1cpkyxJSOiMAgCIBuJZQDImC0HwkxXIIAA/vFZl5IJhslq17NV0IYYAAA=',
  },
  '/images/apps/about/subtop_bg_01_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAAAwAwCdASogABcAPt1kqU+xJaOiKAqqIBuJZQDHMBnSFuyAAP7xZHSa3dvaRwo1j28Lim5nGBxsQwAA',
  },
  '/images/apps/common/SubtopSolution_bg_01.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRj4AAABXRUJQVlA4IDIAAADwAgCdASogABkAPt1mq1EopSOnKAgBEBuJaQAAPbY4AAD+8TjuCCss8QqtvrAFadIAAA==',
  },
  '/images/apps/common/SubtopSolution_bg_01_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkQAAABXRUJQVlA4IDgAAAAwAwCdASoeACAAPsVSoUynpSMiN+gA8BiJaQAAuVyrpbUAAP7zUah/CHobK1P33lPW14vMN5gAAA==',
  },
  '/images/apps/common/subtop_img_01.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAAAwAwCdASogAAgAPt1cpkyopSOiMAgBEBuJYwAAidtMBJ+AAP7worehn5ORUBsaSsVSxQ0ZLP14TcQF9JhkAAAA',
  },
  '/images/apps/common/subtop_img_01_m.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAABQAwCdASogABAAPt1ep003JSOiMAgC4BuJQBOgBZuF0vyNcAD+8FteXmjSSkl5fdzmPmTunIVnDtpsVk+sGcAA',
  },
  '/images/apps/home/logo_daegu_seogu-transparent.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAAAwBACdASogAAgAPt1cqUyopSQiMAgBEBuJbACdMoMYADu7/OJ+u8SAVmgA/rGC5Zz1t0LYtpIx/zKfxgymm/eH5SyVw6mTCRhLfeaqEyXNCYfPH3ja4NPsIjPGjK+msnMyTNyuurkAAA==',
  },
  '/images/apps/home/logo_incheon_transit.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAACQAwCdASogAAgAPt1cp0yopSOiMAgBEBuJZQC7ACHftQvX3kAAAP7trPB7zO/v+t64nFV2VTQCAAAA',
  },
  '/images/apps/home/logo_seongju-transparent.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRloAAABXRUJQVlA4IE4AAACwAwCdASogAA0APt0+s1SooiWjmAEQG4lsAJ0ygANUKDOgu/DwIAD+cO5139wmaDQbkv9tZvjUUrfApXw7r44xrK3mWGb/CBYrLluugAA=',
  },
  '/images/apps/home/logo_seongju.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRkoAAABXRUJQVlA4ID4AAAAwAwCdASogAA8APt1ep00opSOiMAgBEBuJZ12AADc1uPuwAP7wMKT//diRBEGkg1hZQHE+B3Gvm+y5SxKQAA==',
  },
  '/images/apps/home/logo_tai-transparent.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRlgAAABXRUJQVlA4IEwAAADQAwCdASogAAsAPt0+s1SroiWjmAFwG4loAJ0ygAmlNZFHgGSiIAAA/rvvWcWTc18zZz56mwNR0lZ1Nxda7cjoFAFXiK0LEujGAAAA',
  },
  '/images/apps/home/sec_01_video_01_poster.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRmAAAABXRUJQVlA4IFQAAAAwAwCdASogABIAPt1mq1EopSOqqAgBUBuJQBdmWhhQasoIAP7woxHGmPEOOtf7h7xD6h5+Ur27/2G9FUtri/Sxrbv8T9PSRa2ZCEg5cUd5ScIxgAA=',
  },
  '/images/apps/home/sec_02_bg_01.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAADwAgCdASogAB8APt1orFCopiQiqAgBEBuJaQAAPaaKAAD+8W2bPQOL+QAAAA==',
  },
  '/images/apps/home/sec_02_bg_01_m.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAADwAgCdASogACAAPt1orFCopiQiqAgBEBuJaQAAPaaKAAD+8W2bPQOL+QAAAA==',
  },
  '/images/apps/home/sec_02_bg_02.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRnYAAABXRUJQVlA4IGoAAAAwBACdASogABEAPt1epUyopSOiMAgBEBuJYgC06BX5bPHQIx50IpfFPOIA/lcA6UaBNoJ9BEv/Wa1Au4j8IPkcu5RZrqoLVziISzta+vKBnejKKq5dkLsgqW1+kxatCMflUFLisPYFowAA',
  },
  '/images/apps/home/sec_02_bg_02_m.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRnwAAABXRUJQVlA4IHAAAABwBACdASogABYAPtFOo0yoJCMiN/qoAQAaCWQAtOgW42NybS7GoIekOtQMAAD+jvtgUWvamDeZFX2AVfNU/iFlXpUlhJ0pKnGQ2t1s5zf/lF+F64jNpdYHYe2yVQWkkIMMQLYlhOlHdNrg+nrNz/AA',
  },
  '/images/apps/home/sec_02_bg_03.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRlAAAABXRUJQVlA4IEQAAADwAwCdASogABEAPsFQoEynpKMiN+gA8BgJaQAAh3WwqMHGZL5RksCAAP6dR2wedKtrYgWrGCTczWLm6tWwd/UaBQAAAA==',
  },
  '/images/apps/home/sec_02_bg_03.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRlwAAABXRUJQVlA4IFAAAACQBACdASogABMAPtFUpEyoJKOiMAwBABoJZQAA35Z+Nzi8YMH0KomxmPQGswAA/iFd1eWOGnejMKEJvP714nGR5pKKomiX+jx2FZM+HtAAAA==',
  },
  '/images/apps/home/sec_02_bg_03_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRlwAAABXRUJQVlA4IFAAAACQBACdASogABMAPtFUpEyoJKOiMAwBABoJZQAA35Z+Nzi8YMH0KomxmPQGswAA/iFd1eWOGnejMKEJvP714nGR5pKKomiX+jx2FZM+HtAAAA==',
  },
  '/images/apps/home/sec_02_bg_04.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRmwAAABXRUJQVlA4IGAAAADQBACdASogABEAPtVWpEyoJKOiMAwBABqJZQCdMy/CZvUTIv+fkmP82SUNHcUdAAD+8N92hEX/XEGfBCl7UxPp4gv8BME8E/uTRSlrIwhqPmvyYgN1Ra16yIfj7DOanAA=',
  },
  '/images/apps/home/sec_02_bg_04_m.jpg': {
    blurDataURL:
      'data:image/webp;base64,UklGRmYAAABXRUJQVlA4IFoAAACwBACdASogABYAPsVSoUynpSMiN+gA8BiJYwDBDoAEaE44wflaO1jZbopwAWQAAP7r/xGdzYKq8boIYjLxNuU4jmN7Ot1XIKrbmOLW8phjhScI3W+ioZCAAAA=',
  },
  '/images/apps/home/sec_03_bg_01.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRnYAAABXRUJQVlA4IGoAAABwBACdASogABMAPs1SokynpKMiN/qoAPAZiUAVJNtIQxhb9WAiWdqOFvTgwAD9RSl8VYJ/hrM0Cn1PL3CXswHGsRQr06xVlwYEIuu56F+rYb8G36bpRG7lhJpHasmT/kRDdmKF0BPVAAAA',
  },
  '/images/apps/home/sec_03_bg_01.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRnIAAABXRUJQVlA4IGYAAADQBACdASogABMAPs1UoUynpKMiN/qoAPAZiWMAt7gh1XDks2XWLqOfDN6hrcCcAAD+6TvJJH2NgmlySLDWo5NqRfe/xOG3yE9XBus0VeuknGzjl5FwzCnL238JKrzb7uGgIGC8QAA=',
  },
  '/images/apps/home/sec_03_bg_01_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRmQAAABXRUJQVlA4IFgAAAAwBACdASogABEAPt1mqE2opiQiMBgIARAbiWQAnTLaQVIWV0rzesUzhMAAyqEK6tfFjuGFMmHxSl6ZHsa9RplQoM5g8eOBvrJMFQiOygVmjX8Xob28k4AA',
  },
  '/images/apps/home/sec_04_bg_01.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAABwAwCdASogAA8APt1cpkyopSOiMAgBEBuJZQCzgC0H01g4dwAA/vDtH7zAgtJOkfCgIJ2+ihuDbd0nkZCRsAAA',
  },
  '/images/apps/home/visual_video_01_poster_c57abee8.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRmoAAABXRUJQVlA4IF4AAABQBACdASogABIAPtlWpEyoMiOiN/VYAkAbCUATpmHQNU5G8iQXV2zvqkcAAP7sQDCmwzkSlceukzxdI9Mtb8d6YsJIzPIq0QHdTG/XH82wBi8iT09b2+ltuufdHAAA',
  },
  '/images/apps/solution/custom/SubtopSolution_img_01.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkgAAABXRUJQVlA4IDwAAABwAwCdASogABIAPt1iq08opTIiKAqqQBuJZwDKtBksMHgfF4AA/u/HGYFCj6K6DjUlreRQ1W1ptTkAAAA=',
  },
  '/images/apps/solution/custom/SubtopSolution_img_01.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAAAQAwCdASogABIAPt1aqU8osqOiMBgIAlAbiWcAAESfcMAA/u/Hwr8aT77xLeCgYta6MdDQBzqWOAAA',
  },
  '/images/apps/solution/custom/SubtopSolution_img_01_en.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkgAAABXRUJQVlA4IDwAAAAwAwCdASogABEAPt1cqU6opKOiMBgIARAbiWcAxNgX5nVUAP7vxOcEkqPpr2D4s++QUV+SDDd9BHS8AAA=',
  },
  '/images/apps/solution/custom/SubtopSolution_img_01_en.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRkgAAABXRUJQVlA4IDwAAAAwAwCdASogABEAPt1eqE4opSOiMBgIARAbiWcAyNQVnjVAAP7vxOY04oU1Pt04jYpti3UaGaGA0KQK0AA=',
  },
  '/images/apps/solution/custom/SubtopSolution_img_01_en_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkgAAABXRUJQVlA4IDwAAAAwAwCdASogABEAPt1cqU6opKOiMBgIARAbiWcAxNgX5nVUAP7vxOcEkqPpr2D4s++QUV+SDDd9BHS8AAA=',
  },
  '/images/apps/solution/custom/SubtopSolution_img_01_en_m.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRkgAAABXRUJQVlA4IDwAAAAwAwCdASogABEAPt1cqU6opKOiMBgIARAbiWcAvVgX5nNgAP7vxObHa8Kan26cUzljN5b8TNIkGK0AAAA=',
  },
  '/images/apps/solution/custom/SubtopSolution_img_01_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAAAQAwCdASogABIAPt1grE6opTKiKAqqUBuJZwDMWBXeSfAA/u/HGYmrNDPrYI2mOqnEm7B1ef6NjmgA',
  },
  '/images/apps/solution/custom/SubtopSolution_img_01_m.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRkQAAABXRUJQVlA4IDgAAAAQAwCdASogABIAPt1cqU6osyOiMBgIAmAbiWcAAESfcMAA/u/HwsMoXu1Yb7nG8nUuNhDVwzAAAA==',
  },
  '/images/apps/solution/industrial/SubtopSolution_img_02.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAABQAwCdASogABIAPtVYoEy7pSMiMAwDcBqJZwC9WDHsAmrGYAD+3/0OKLVYQ+hRjeb5U81CBrU/8VBAN+uFcIohwAA=',
  },
  '/images/apps/solution/industrial/SubtopSolution_img_02_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRlAAAABXRUJQVlA4IEQAAABQAwCdASogABIAPt1YpEy3JSOiMAgC4BuJZwDE2C+wtycVAAD+3/0OKS/nCzXyMlTAKChnIW9JLgkFVT3nrPulyZgAAA==',
  },
  '/images/apps/solution/industrial/dashboard-click-en-v2.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRlAAAABXRUJQVlA4IEQAAACQAwCdASogABQAPt1mqlE3JSOiqAgC4BuJZwDM0BakDnWXuxsAAP7wJtt2TLFBxYjJvV+n7lgawwLs6KLjw7KBsAAAAA==',
  },
  '/images/apps/solution/industrial/dashboard-click-ko-v2.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAACQAwCdASogABQAPt1mqlC3JSOnKAgC4BuJZwAAPizWSAB+VdCAAP7wQl5Hqk9S1XW10nAgFe2aQtMcn92yAAAA',
  },
  '/images/apps/solution/industrial/dashboard-motor-en-v2.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAAAwAwCdASogABQAPt1mp0+opagiKAqpEBuJZQDNwBk25/AAAP7wWqnrpzwNvcgRfcpEAD4hfBLjDnAA',
  },
  '/images/apps/solution/industrial/dashboard-motor-ko-v2.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkoAAABXRUJQVlA4ID4AAAAQAwCdASogABQAPt1kqE+opaOiKAqpEBuJZQDM0BWdkIAA/vBavQrtuNlsccexREjuyO0OmdlP3JJurlAAAA==',
  },
  '/images/apps/solution/industrial/sec_01_img_01.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAABwAwCdASogAA4APt1cpkyopSOiMAgBEBuJZwDCgDKK27AhisQA/vB1yaE/HdQloRe88DVjZlFzwIAA',
  },
  '/images/apps/solution/industrial/sec_01_img_01_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAABwAwCdASogAA4APt1cpkyopSOiMAgBEBuJZwDCgDKK27AhisQA/vB1yaE/HdQloRe88DVjZlFzwIAA',
  },
  '/images/apps/solution/industrial/sec_01_img_02.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRlAAAABXRUJQVlA4IEQAAADQAwCdASogABAAPt0+s1SooiWjmAEQG4ljAJ0AId4nDl01j4d9/3gA/hCpX3Awt7fG0Lf7gWTgSwAot0Fe0uhRJgjAAA==',
  },
  '/images/apps/solution/industrial/sec_01_img_02_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRlAAAABXRUJQVlA4IEQAAADQAwCdASogABAAPt0+s1SooiWjmAEQG4ljAJ0AId4nDl01j4d9/3gA/hCpX3Awt7fG0Lf7gWTgSwAot0Fe0uhRJgjAAA==',
  },
  '/images/apps/solution/industrial/sec_01_img_03.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAABQAwCdASogABAALqVut1ujKKioiICkSzgABc0MgMT+kk54AADcRr0er8i3qpJbDyiwKdh6pS38YN8A2MHjDxEAAAA=',
  },
  '/images/apps/solution/industrial/sec_01_img_03_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAABQAwCdASogABAALqVut1ujKKioiICkSzgABc0MgMT+kk54AADcRr0er8i3qpJbDyiwKdh6pS38YN8A2MHjDxEAAAA=',
  },
  '/images/apps/solution/industrial/sec_03_img_01.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRlAAAABXRUJQVlA4IEQAAABQAwCdASogABAALqVut1ujKKioiICkS0gAAsWJI9J47IJ1AAD+8aVyrqKViHuSztEOJxrNlpUXrnJt8i/6rDrkmMKAAA==',
  },
  '/images/apps/solution/industrial/sec_03_img_01_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRlAAAABXRUJQVlA4IEQAAABQAwCdASogABAALqVut1ujKKioiICkS0gAAsWJI9J47IJ1AAD+8aVyrqKViHuSztEOJxrNlpUXrnJt8i/6rDrkmMKAAA==',
  },
  '/images/apps/solution/industrial/sec_03_img_02.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRlAAAABXRUJQVlA4IEQAAADQAwCdASogABAAPt0+s1SooiWjmAEQG4ljAJ0AId4nDl01j4d9/3gA/hCpX3Awt7fG0Lf7gWTgSwAot0Fe0uhRJgjAAA==',
  },
  '/images/apps/solution/industrial/sec_03_img_02_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRlAAAABXRUJQVlA4IEQAAADQAwCdASogABAAPt0+s1SooiWjmAEQG4ljAJ0AId4nDl01j4d9/3gA/hCpX3Awt7fG0Lf7gWTgSwAot0Fe0uhRJgjAAA==',
  },
  '/images/apps/solution/industrial/sec_03_img_03.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAABQAwCdASogABAALqVut1ujKKioiICkSzgABc0MgMT+kk54AADcRr0er8i3qpJbDyiwKdh6pS38YN8A2MHjDxEAAAA=',
  },
  '/images/apps/solution/industrial/sec_03_img_03_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAABQAwCdASogABAALqVut1ujKKioiICkSzgABc0MgMT+kk54AADcRr0er8i3qpJbDyiwKdh6pS38YN8A2MHjDxEAAAA=',
  },
  '/images/apps/solution/industrial/sec_04_img_01.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkAAAABXRUJQVlA4IDQAAAAQAwCdASogABAAPt1cpkyxJSOtsAgCIBuJaQAAetCs1qAA/vAmtsLDOpiuf2GKokQdYQAA',
  },
  '/images/apps/solution/industrial/sec_04_img_01_en.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkIAAABXRUJQVlA4IDYAAAAwAwCdASogABIAPt1iq08rpSkiKAqpcBuJaQAAOob1gUIAAP7vpwzVOyk5xWDMvgSxoPgQAAA=',
  },
  '/images/apps/solution/safety/SubtopSolution_img_01.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRm4AAABXRUJQVlA4IGIAAADwAwCdASogABIAPt1apUyopSOiMAgBEBuJYwClrB6F3abYVxLv8YQAAP7r/+MdBY8IDcXDqHVnpidOjac+sDI0dspireofU8Nx8ACRPVoyqB6hFUDQwk60xXTy/BFzNaAAAA==',
  },
  '/images/apps/solution/safety/SubtopSolution_img_01.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRm4AAABXRUJQVlA4IGIAAAAQBQCdASogABIAPt1gqU6opaQiMBgIARAbiWMAnSFBAYFqzm4/1koZGPtzgvB5teIoAP7vJc3YteLsFzAZZW6O079FQbOUAQejPC4hPW3A6oYpgZeAZ5SbY0d6ttCncwiAAA==',
  },
  '/images/apps/solution/safety/SubtopSolution_img_01_en.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRkAAAABXRUJQVlA4IDQAAABQAwCdASogAA4APt1apkyrpSOiMAgBcBuJZQAAg++0HdkJUAD+7+OQiDQoLAqS6tfl4AAA',
  },
  '/images/apps/solution/safety/SubtopSolution_img_01_en_m.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRkAAAABXRUJQVlA4IDQAAABQAwCdASogAA4APt1apkyrpSOiMAgBcBuJZQAAg++0HdkJUAD+7+OQiDQoLAqS6tfl4AAA',
  },
  '/images/apps/solution/safety/SubtopSolution_img_01_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRm4AAABXRUJQVlA4IGIAAADwAwCdASogABIAPt1apUyopSOiMAgBEBuJYwClrB6F3abYVxLv8YQAAP7r/+MdBY8IDcXDqHVnpidOjac+sDI0dspireofU8Nx8ACRPVoyqB6hFUDQwk60xXTy/BFzNaAAAA==',
  },
  '/images/apps/solution/safety/SubtopSolution_img_01_m.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRmwAAABXRUJQVlA4IGAAAACwBACdASogABIAPt1gp06opaMiMBgIARAbiWMAnQAQ7PRrRSGvY6KNrxS9ix7gAP7vJc3YteLsCBRpi9hAb/l/64hJz57zoYT38BweiQPs4xwC7caDiFC0dbaPanEJQAA=',
  },
  '/images/apps/solution/safety/case-park-restroom.webp': {
    blurDataURL:
      'data:image/webp;base64,UklGRnQAAABXRUJQVlA4IGgAAABQBQCdASogABgAPs1QokynpKMiN/qoAPAZiWwAnTmBvGpf4Ar4ls8QtcQ++qje/mYqL8AA+Z+hxJG92svpF2EBGDb+0G6rsQ9dBEocKaMRp+jfhJqXNQOKPIcHpeSwvRz6AridXQAAAA==',
  },
  '/images/apps/solution/safety/sec_03_img_01.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRmQAAABXRUJQVlA4IFgAAACwAwCdASogAA4APt1iqUyopiQiMAgBEBuJZQCxC8AJBPqQt2zDAgD9ZfOa2BH83y1ajoENGGSywRbUkV9+yKv+1m8NqRdCBju9UDMmbtKv86oGX/d5QAAA',
  },
  '/images/apps/solution/safety/sec_03_img_01_en.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRmQAAABXRUJQVlA4IFgAAADQAwCdASogABAAPt1cp0yopSOiMAgBEBuJYwDA3B6JinohF2+VN8AA/umsP+TgBdSzU0owMI4LFqFcF9znYiq49QvwDycvrz+gcQWW8XeqZQvF7e16C/AA',
  },
  '/images/apps/solution/safety/sec_03_img_01_en_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRngAAABXRUJQVlA4IGwAAADQBACdASogABUAPtlWpEyoJKOiN/VYAQAbCWMAxPk7gX+KML8u4o0FwCzpm1eqAAD+9oYBh8Gztg2qOmc7S6ddjB8Q63CMTlSOPSpMJnkbvALAsF6LXbp4zYdk2HOK0MFzsCQr1qIEXkkwAAA=',
  },
  '/images/apps/solution/safety/sec_03_img_01_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRmQAAABXRUJQVlA4IFgAAACwAwCdASogAA4APt1iqUyopiQiMAgBEBuJZQCxC8AJBPqQt2zDAgD9ZfOa2BH83y1ajoENGGSywRbUkV9+yKv+1m8NqRdCBju9UDMmbtKv86oGX/d5QAAA',
  },
  '/images/apps/technology/sec_05_img_01.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRkgAAABXRUJQVlA4IDwAAABQAwCdASogAAsALqVut1ujKKioiICkS0gABc2gYnWhRlaQAAD+4AWiynYCTCKJcN333/zwRC82YaMQAAA=',
  },
  '/images/apps/technology/sec_05_img_01_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRlIAAABXRUJQVlA4IEYAAABwBACdASoeACAAPt1St1uooyWllAEQG4lpAAAiNRDzOlBae9P5MaO/wiRZQAD+5z8VpC8wBy7sjaOQb0+BOYcMa+aYXAAA',
  },
  '/images/apps/technology/sec_05_img_02.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRmQAAABXRUJQVlA4IFgAAACwAwCdASogAA4APt1iqUyopiQiMAgBEBuJZQCxC8AJBPqQt2zDAgD9ZfOa2BH83y1ajoENGGSywRbUkV9+yKv+1m8NqRdCBju9UDMmbtKv86oGX/d5QAAA',
  },
  '/images/apps/technology/sec_05_img_02_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRmwAAABXRUJQVlA4IGAAAAAwBQCdASogABYAPt1eqE0opSQiKA1REBuJZwAALGN2z2LBAF672MEGAZ+3lCbIez9AAAD+6pblvaXMLob3eyn0/80e9rgZ4YuIWyRUHHX/E60yPNNcqc9wq4QrJlCAAAA=',
  },
  '/images/apps/technology/sec_05_img_02_m_en.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRnAAAABXRUJQVlA4IGQAAADwBACdASogABYAPtFSpUyoJKOiN/qoAQAaCWMAzFgh3Ke2YrScSz1jU4Kk4R4zOBgA/vd2S/CeaHwegnaLaQ+2NgJoo4CFcU952Bv8FfjP8FG5X/7/yK3CKm8V56k7VTEg38AA',
  },
  '/images/apps/technology/sec_05_img_03_m.png': {
    blurDataURL:
      'data:image/webp;base64,UklGRm4AAABXRUJQVlA4IGIAAABwBQCdASogABgAPt1kqU6opaQiMBgIARAbiWkAAI92XzXw9fIXVdBaUXaSwpaJf3mcji3AAP73DuGQyChoJMrTN6Q7hKpwIxwJFsKCudo3Ygraoh4coOfA58wqADuQVQAAAA==',
  },
} as const;
